import React from 'react';
import '../index.css';

function Spinner(){
    return (
        <div>
            <div className="spinner"></div>
        </div>
    )
}

export default Spinner;